var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1188 3.07892L11.248 6.23323H4.62074V17.9492H15.2835L15.2827 12.3335L18.1542 9.17906V18.3998C18.1542 19.893 17.0526 21.1035 15.6936 21.1035H4.21063C2.85166 21.1035 1.75 19.893 1.75 18.3998V5.78261C1.75 4.2894 2.85166 3.07892 4.21063 3.07892H14.1188ZM15.8896 4.83197L17.4908 6.59147L10.7548 13.9429L8.55708 14.5118L9.203 12.0912L15.8896 4.83197ZM18.9322 3.27285C19.3649 3.77204 19.3549 4.55814 18.9097 5.04395L18.0727 5.95706L16.4732 4.19947L17.3516 3.24644L17.3687 3.22829C17.8117 2.76773 18.5117 2.78768 18.9322 3.27285Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/edit.icon.b55db79c1ba8acb8ca5e9d0ce46cba19.svg";
export { ForwardRef as ReactComponent };